export function headerInit() {

	const submenuButton = document.querySelectorAll(".open-submenu");
	const langButton = document.querySelector(".site-header-lang-toggle");
	const langDropdown = document.querySelector(".site-header-lang-dropdown");
	const mainmenuButton = document.querySelector(".toggle-expand-main-menu");
	const mainmenuElement = document.querySelector(".site-header-menu-mobile");
	const mqLarge = window.matchMedia( "(min-width: 1200px)" );
	const menuWrapper = document.querySelector(".site-header-lang-mobile");

	var menuItems = document.querySelectorAll('li.menu-item-has-children');
	var langMenu = document.querySelectorAll('.site-header-lang-toggle');
	var timer;
	var langTimer;

	//Toggle logic for button elements
	if (submenuButton) {
		submenuButton.forEach((el) =>
			el.addEventListener("click", (event) => {
				const subMenu = event.target.closest('.menu-item-has-children');
				subMenu.classList.toggle("open");
				
				if (subMenu.classList.contains('open')) {
					event.target.setAttribute("aria-expanded", "true");
				}
				else {
					event.target.setAttribute("aria-expanded", "false");
				}
			})
		);
	}

	if (langButton) {
		langButton.addEventListener("click", () => {
			langDropdown.classList.toggle("open");

			if (langDropdown.classList.contains('open')) {
				langButton.setAttribute("aria-expanded", "true");
			}
			else {
				langButton.setAttribute("aria-expanded", "false");
			}
		})
	}


	if (mainmenuButton) {
		mainmenuButton.addEventListener("click", () => {
			mainmenuButton.classList.toggle("open");
			mainmenuElement.classList.toggle("open");

			if (mainmenuButton.classList.contains('open')) {
				mainmenuButton.setAttribute("aria-expanded", "true");
				document.body.style.overflow = "hidden";
			}
			else {
				mainmenuButton.setAttribute("aria-expanded", "false");
				document.body.style.overflow = "scroll";
			}
			mobileMenuFocus();
		})
	}

	//Functions for menu hover actions
	function openHoverMenu() {
		Array.prototype.forEach.call(menuItems, function(el, i){
			if ( el.classList.contains("open") ) {
				el.classList.remove("open");
			}
		});

		this.classList.add("open");
		clearTimeout(timer);
	}

	function closeHoverMenu() {
		timer = setTimeout(function() {
			document.querySelector(".menu-item-has-children.open").classList.remove("open");
		}, 500);
	}

	function openHoverLangMenu() {
		langButton.setAttribute("aria-expanded", "true");
		document.querySelector(".site-header-lang-dropdown").classList.add("open");
		clearTimeout(langTimer);
	}

	function closeHoverLangMenu() {
		langTimer = setTimeout(function() {
			document.querySelector(".site-header-lang-dropdown").classList.remove("open");
			langButton.setAttribute("aria-expanded", "false");
		}, 500);
	}

	//Trap focus inside mobilemenu if it's open. This function is called if screensize is 
	function mobileMenuFocus() {
		const focusableElements = Array.from(
          	menuWrapper.querySelectorAll('button, a')
        );
        var firstFocus = focusableElements[0];
       	var lastFocus = focusableElements[focusableElements.length - 1];
		
		// If user tabs in last element focus moves to the first one
		lastFocus.addEventListener('keydown', function (e) {
			if (e.key === 'Tab' && !e.shiftKey) {
				if (mainmenuButton.classList.contains('open')) {
					e.preventDefault();
					firstFocus.focus();
				}
			}
		});

		// If user tabs backwards from the first element, moves to the last
		firstFocus.addEventListener('keydown', function (e) {
			if (e.key === 'Tab' && e.shiftKey) {
				if (mainmenuButton.classList.contains('open')) {
					e.preventDefault();
					lastFocus.focus();
				}
			}
		});
	}

	//Handle mouseover actions and listening in desktop
	function handleDesktopChange(e) {
		//Run if breakpoint large or bigger
		if (e.matches) {
			Array.prototype.forEach.call(menuItems, function(el, i){
				el.addEventListener("mouseover", openHoverMenu);
				el.addEventListener("mouseout", closeHoverMenu);
			});

			Array.prototype.forEach.call(langMenu, function(el, i){
				el.addEventListener("mouseover", openHoverLangMenu);
				el.addEventListener("mouseout", closeHoverLangMenu);
			});
		}
		else {
			//On tablet and mobile, remove event listeners from menu items that have children
			Array.prototype.forEach.call(menuItems, function(el, i){
				el.removeEventListener("mouseover", openHoverMenu);
				el.removeEventListener("mouseout", closeHoverMenu);
			});
		}
	}

	// Register event listener to listen screen width changes
	mqLarge.addListener(handleDesktopChange);

	// Initial check
	handleDesktopChange(mqLarge)
}